import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware'

interface IReclamosLineaStore {
    cliente: string 
    updateCliente: (newCliente: string) => void
}

export const useReclamosLineaStore = create<IReclamosLineaStore>()(
    devtools(
      persist(
        (set) => ({
            cliente: '',
            updateCliente: (newCliente: string ) => set({ cliente: newCliente }),
        }),
        {
          name: 'reclamoslinea-storage',
        }
      )
    )
  )